import getApi from '../../api'

export const deleteQuestionnaireTemplate = (id: number) =>
  getApi().delete<void>(`/questionnaire_templates/${id}`)
